import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from './../common/AcountingId'
import * as lb from './../common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../../common/svg/refresh'
import { SplitButton } from '../../../common/SplitButton'
import { AcountingHeading } from './../common/AcountingHeading'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { getPartyCreditLimitTransRptData, getOwnChildBranches, getReportBranchList } from '../../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError, updateModal } from '../../../../store/common/common_action'
import TableViewCreditTransaction from './TablePartywiseCreditLimitTransactionReport'
import ManageColumns from '../../../common/ManageColumnsUI'
import { creditTransReportColumnParty, creditTransReportColumnPartyForBoth, creditTransReportColumnPartyFormattedLRNO, creditTransReportColumnPartyWithNewComm } from './../common/AcountingConstants'
import { getPartyConfigTableData } from '../../../../store/generalSetting/GSAction'
const PartywiseCreditLimitTransactionReport = (props) => {
  const {
    data: { common, reports, generalSettingReducer },
    getPartyConfigTableData,
    getPartyCreditLimitTransRptData,
    updateAlertError,
    updateModal,
    getOwnChildBranches,
  } = props
  const { ownChildBranches1, partycreditTransReportData } = reports
  const { loginData, roleRights, showModal, modalType,companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const PartyCrlTxnsPortrait   = companySettings?.[0]?.IsPartyCrlTxnsPortrait   || 0
  const { partyConfigTableData } = generalSettingReducer
  const reportName = 'Party Credit Limit Transaction'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selParty, setSelParty] = useState([])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [resetCity, setResetCity] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [creditTransTableData, setCreditTransTableData] = useState([])
  const selectedFields = manageColumn?.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  useEffect(() => {
    focusElemnt(id.creditTransFromDate)
  }, [])
  // const PartyCrlTxnsPortrait =1
  useEffect(()=>{
    if(!isEmpty(loginData)){
      let creditTransReportColumnPartyHeader=UseFormattedLRinReports===0||UseFormattedLRinReports===1?creditTransReportColumnParty:UseFormattedLRinReports===2?creditTransReportColumnPartyFormattedLRNO:creditTransReportColumnPartyForBoth
      // if(loginData?.intCompanyID===1){
      //   setManageColumn(creditTransReportColumnPartyWithNewComm)
      // }else{
       if (PartyCrlTxnsPortrait === 1) {
                  creditTransReportColumnPartyHeader = creditTransReportColumnPartyHeader.filter((item) => item.isMandatory === true)
        }
        setManageColumn(creditTransReportColumnPartyHeader)
      // }
    }
  },[loginData])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let object = {
        intPartyID: 0,
        intCompanyID: loginData?.intCompanyID,
        strPartyName: "",
        strContactPerson: "",
        intCityID: 0,
        intIsCreditParty: -1,
        intIsActive: -1,
        intIsDeleted: -1
      }
      getPartyConfigTableData(object)
    }
  }, [loginData])
  useEffect(() => {
    if (partycreditTransReportData.length > 0) {
      const creditTransactionReportUpdatedData = partycreditTransReportData.map((val) => {
        const bkgDateTime = val.BookingDateTime !== ''
          ? `${moment(val.BookingDateTime).format('DD-MMM-YY')}\n${new Date(val.BookingDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
          : 'N/A';
        return {
          ...val,
          LRNO: val.BookingDateTime !== '' ? val.LrNo : 'N/A',
          BookingDateTime: bkgDateTime,
        };
      });
      setCreditTransTableData(creditTransactionReportUpdatedData)
    }
  }, [partycreditTransReportData])
  useEffect(() => {
    if (!isEmpty(ownChildBranches1)) {
      if (ownChildBranches1?.length > 0) {
        const { intBranchCityID, strCityName } = loginData;
        const { stateList } = ownChildBranches1.reduce(
          (acc, val) => {
            const { StateID, StateName } = val
            if (!acc.statesMap.has(StateID)) {
              acc.statesMap.set(StateID, { StateID, StateName })
              acc.stateList.push({ StateID, StateName })
            }
            return acc
          },
          {
            statesMap: new Map(),
            stateList: [],
          }
        )
        setStateList([{ StateName: 'All', StateID: 0 }, ...stateList])
        setSourceCityList([{ CityName: 'All', CityID: 0 }, ...ownChildBranches1])
        const selectedState = ownChildBranches1.find(obj => obj.CityID === intBranchCityID);
        setSelState({
          StateName: selectedState?.StateName || '',
          StateID: selectedState?.StateID || '',
        });
        setSelSourceCity({ CityName: strCityName, CityID: intBranchCityID })
      } else {
        setStateList([])
        setSourceCityList([])
        setSelState('')
        setSelSourceCity('')
      }
    }
  }, [ownChildBranches1])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      //setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  const handleClick1 = () => {
    if (selState == '' || selState == ' ') {
      updateAlertError({ show: true, msg: 'Select State', nextId: '' })
    }
    if (selSourceCity == '' || selSourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    }
    if (selParty == '' || selParty == ' ') {
      updateAlertError({ show: true, msg: 'Select Party', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
    } else {
      setIsExpanded(true)
      const obj = {
        CompanyID: loginData?.intCompanyID,
        PartyID: selParty?.PartyID,
        CityID: selSourceCity?.CityID,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
      }
      getPartyCreditLimitTransRptData(obj)
    }
  }

  const handleClick2 = () => {
    let url = URL.partyCreditLimitTransactionReport
    const urlData = URL.partyCreditLimitTransactionReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intFromCityId = selSourceCity?.CityID
    urlData.intPartyId = selParty?.PartyID
    urlData.FromCity = selSourceCity?.CityName
    urlData.PartyName = selParty?.Party
    urlData.FromDate = fromDate.format('DD-MMM-YYYY')
    urlData.ToDate = toDate.format('DD-MMM-YYYY')
    urlData.intAllowExportToExcel = 1
    urlData.Mode = 4
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    localStorage.setItem('creditTransReport', JSON.stringify(items))
    // localStorage.setItem(loginData?.intCompanyID === 1 ? 'creditTransReportColumnPartyWithNewComm' : 'creditTransReportColumnParty', JSON.stringify(items))
  }
  const getCityList = () => {
    if (!selState.StateID) {
      return sourceCityList || []
    } else {
      const filteredCities = sourceCityList.filter((state) => state.StateID === selState.StateID)
      return [{ CityName: 'All', CityID: 0 }, ...filteredCities]
    }
  }
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompany}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="250px"
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              // name={'from_date'}
              id={id.creditTransFromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              startDate={'2022-01-01'}
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
              }}
              startDate={'2022-01-01'}
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={stateList || []}
              defaultvalue={selState?.StateName}
              idKey={`StateID`}
              dataKey={`StateName`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                setResetCity(true)
              }}
              isObjArr={true}
              width="310px"
              nextId={id.srcCity}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Select City'}
              data={getCityList()}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceCity(val)
                setResetCity(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By City`}
              width="310px"
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Select Party'}
              data={partyConfigTableData || []}
              defaultvalue={selParty?.Party}
              dataKey={`Party`}
              idKey={`PartyID`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelParty(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Party`}
              width="310px"
              nextId={id.creditTransSplitButton}
              prevId={id.srcCity}
              resetFlag={resetCity || resetFlag}
            //  disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, isExpanded ? 'creditTransExcelBtn' : id.creditTransFromDate, () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              //hideToggle={false}
              id1={id.creditTransSplitButton}
              prevID={disableBtn ? id.toDate : id.srcBranch}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
              setSelState([])
              setSelSourceCity([])
              setSelParty([])
              setFromDate(moment(new Date()))
              setToDate(moment(new Date()))
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          <TableViewCreditTransaction
            reportData={creditTransTableData}
            loginData={loginData}
            fromDate={fromDate}
            toDate={toDate}
            company={loginData?.strCompanyName}
            StateName={selState?.StateName}
            city={selSourceCity?.CityName}
            party={selParty?.Party}
            updateModal={updateModal}
            columns={manageColumn}
            selectedFields={selectedFields}
            UseFormattedLRinReports={UseFormattedLRinReports}
          />
        ) : (
          ''
        )}
      </Item>
      {showModal && modalType === 'showManageColumnForCreditTrans' && (
        <ManageColumns
          headers={manageColumn}
          onSave={onSaveColumns}
          updateModal={updateModal}
          headTxt={`Columns for Party Credit Limit Transaction Report`}
        />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getOwnChildBranches,
  getPartyConfigTableData,
  getBranchConfigOrEwbillinfo,
  getReportBranchList,
  getPartyCreditLimitTransRptData,
  updateAlertError,
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(PartywiseCreditLimitTransactionReport)
